const englishPageData = {
  slug: 'english',
  code: 'en',
  name: 'English',
  nativeName: 'English',
  flag: '🇬🇧',
  accent: 'from-sky-500 to-indigo-600',
  description: 'Summary notes and quick references for English learners.',
  notes: { summary: [], keyPoints: [], quickReference: [] },
};

export default englishPageData;
